import { Component, OnInit, ViewChild } from '@angular/core';
import { CustomerTableDto } from 'src/app/entity/customerTableDto';
import { CustomerDetailDto } from 'src/app/entity/customerDetailDto';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { CustomerService } from 'src/app/customer/customer.service';
import { Router } from '@angular/router';
import { CustomerDetailViewComponent } from 'src/app/customer/customer-detail-view/customer-detail-view.component';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CustomerEditViewComponent } from '../customer-edit-view/customer-edit-view.component';

@Component({
  selector: 'app-customer-table-view',
  templateUrl: './customer-table-view.component.html',
  styleUrls: ['./customer-table-view.component.scss'],
})
export class CustomerTableViewComponent implements OnInit {
  customers: MatTableDataSource<CustomerTableDto>;
  displayedColumns: string[] = [
    'name',
    'licenceCount',
    'manufacturerCount',
    'userCount',
    'buttons',
  ];

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  constructor(
    private router: Router,
    private customerService: CustomerService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.customers = new MatTableDataSource<CustomerTableDto>();

    this.customerService.getCustomers().subscribe((res) => {
      this.customers.data = res;
      console.log(res);
    });

    if (this.customers !== undefined) {
      this.customers.sort = this.sort;
    }
  }

  showDetails(customerId: number): void {
    console.log(customerId);

    this.customerService.getCustomerDetails(customerId).subscribe((res) => {
      res.id = customerId;
      const dialogRef = this.dialog.open(CustomerDetailViewComponent, {
        data: res,
      });
    });
  }

  createNewCustomer() {
    const newCustomer = new CustomerDetailDto();
    const dialogRef = this.dialog.open(CustomerEditViewComponent, {
      data: newCustomer,
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.customerService.getCustomers().subscribe((res) => {
        this.customers.data = res;
      });
    });
  }

  edit(customerId: number): void {
    console.log(customerId);

    this.customerService.getCustomerDetails(customerId).subscribe((res) => {
      res.id = customerId;
      const dialogRef = this.dialog.open(CustomerEditViewComponent, {
        data: res,
      });
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.customers.filter = filterValue.trim().toLowerCase();
  }
}
